/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agent_1_DescInputs */

const en_mk_agent_1_desc = /** @type {(inputs: Mk_Agent_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The moment an issue is assigned to an agent, the queue picks it up. The status moves itself to “In progress”, then to “In review” when the result is ready for you.`)
};

const id_mk_agent_1_desc = /** @type {(inputs: Mk_Agent_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begitu issue di-assign ke agen, antrean menjalankannya. Status berubah sendiri jadi "Dikerjakan", lalu "Perlu review" ketika hasilnya siap Anda periksa.`)
};

/**
* | output |
* | --- |
* | "The moment an issue is assigned to an agent, the queue picks it up. The status moves itself to “In progress”, then to “In review” when the result is ready fo..." |
*
* @param {Mk_Agent_1_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agent_1_desc = /** @type {((inputs?: Mk_Agent_1_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agent_1_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agent_1_desc(inputs)
	return en_mk_agent_1_desc(inputs)
});